import useCountry from "../../../../lib/utils/hooks/useCountry"
import {ISlot, TEventData} from "../../../../lib/utils/types";

type TProps = {
    selectedEvent?: TEventData,
    selectedSlot?: ISlot,
    peopleAmount: number
}

export function useBookingLimit({selectedEvent, selectedSlot, peopleAmount}: TProps) {
    const country = useCountry();

    const showBookingLimitEvent = selectedEvent?.show_booking_limit;
    const showBookingLimitSlot = selectedSlot?.show_booking_limit;

    const eventCorporateOfferQuantity = selectedEvent?.corporate_offer_quantity;
    const slotCorporateOfferQuantity = selectedSlot?.corporate_offer_quantity;

    let minCorporateOffer, corporateLimit

    if(eventCorporateOfferQuantity && slotCorporateOfferQuantity) {
        minCorporateOffer = Math.min(eventCorporateOfferQuantity, slotCorporateOfferQuantity)
    }

    if(showBookingLimitEvent && showBookingLimitSlot) {
        corporateLimit = minCorporateOffer
    } else if (showBookingLimitEvent) {
        corporateLimit = eventCorporateOfferQuantity
    } else if (showBookingLimitSlot) {
        corporateLimit = slotCorporateOfferQuantity
    }
    
    const isCorporateLimitReached = corporateLimit ? peopleAmount >= corporateLimit : false;                            
    const shouldShowCorporateWarning = (showBookingLimitEvent || showBookingLimitSlot) && isCorporateLimitReached;
    const isBookingLimitVisible = selectedSlot?.show_booking_limit || selectedEvent?.show_booking_limit;
    const isExactly20 = peopleAmount === 20;
    const isCorporate = selectedSlot?.corporate_offer_quantity
            ? peopleAmount >= selectedSlot.corporate_offer_quantity
            : false;

    const isRussia = country === 'RU';
    const isNotExactly20 = !isExactly20 && isBookingLimitVisible && isCorporate

    return {isBookingLimitVisible, isExactly20, isRussia, shouldShowCorporateWarning, isNotExactly20}
}